export const RECORD_LOAD = "record/on_load";
export const recordLoad = () => ({
  type: RECORD_LOAD,
});

export const RECORD_LOAD_SUCCESS = "record/on_load_success";
export const recordLoadSuccess = (data, recordData) => ({
  type: RECORD_LOAD_SUCCESS,
  payload: {
    plan: data,
    recordData: recordData
  }
});
